import { KeyActionTypes } from "./actionTypes";

export const KeyActionCreators = {
    getKeyRequests: ({ page = 0, top = 10 }) => ({
        type: KeyActionTypes.GET_REQUESTS,
        payload: { page, top }
    })
};
